<template>
  <div
    v-bind:class="{ workingCell: isWorking }"
    style="height:100%;width:100%"
    v-if="data"
  ></div>
</template>

<script>
export default {
  methods: {
    inSchedule() {},
  },
  created() {
    var providerSchedules = this.providersSchedules[this.data.groupIndex + 1];
    this.isWorking = false;
    for (let i = 0; i < providerSchedules.length; i++) {
      if (
        new Date(providerSchedules[i].startDate) <= new Date(this.data.date) &&
        new Date(providerSchedules[i].endDate) > new Date(this.data.date)
      ) {
        this.isWorking = true;
        break;
      }
    }
  },
  props: { providersSchedules: [] },
  data() {
    return { isWorking: false, data: null };
  },
};
</script>

<style scoped>
.workingCell {
  background-color: #c5d0db;
}
</style>
